var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntuitiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 18C28 18 10.92 30.44 4 48C10.92 65.56 28 78 48 78C68 78 85.08 65.56 92 48C85.08 30.44 68 18 48 18ZM48 68C36.96 68 28 59.04 28 48C28 36.96 36.96 28 48 28C59.04 28 68 36.96 68 48C68 59.04 59.04 68 48 68ZM48 36C41.36 36 36 41.36 36 48C36 54.64 41.36 60 48 60C54.64 60 60 54.64 60 48C60 41.36 54.64 36 48 36Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntuitiveIcon);
export default __webpack_public_path__ + "static/media/intuitiveIcon.7ecbf8cb2a490ae5cbd81705deddf5c5.svg";
export { ForwardRef as ReactComponent };